import MaxPointsRewardCalculationTypeEditor from "../../../pages/actionModules/ActionModuleEditor/RewardCalculationEditor/MaxPointsRewardCalculationTypeEditor";
import { RewardCalculationTypeDefinition } from "../actionModule";
import { RewardCalculationType } from "./rewardCalculationType";

export const MaxPointsRewardCalculationType: RewardCalculationTypeDefinition = {
    name: "actionModules.rewardCalculationType.maxPoints.name",
    defaultValue: {},
    type: RewardCalculationType.MaxPointsCalculationType,
    editor: () => <MaxPointsRewardCalculationTypeEditor />
};